/* 🤖 this file was generated by script */
export const wiconDownload04 = {
  name: 'download_04',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 12l4 4m0 0l4-4m-4 4V6.8c0-1.4 0-2.09-.55-2.86A3.87 3.87 0 009.4 2.69c-.94-.12-1.3.06-2.02.44a10 10 0 109.62.2"/></svg>`,
};
